var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"adminLink",class:{
    'adminLink--active': _vm.active,
    'adminLink--arrowbefore': _vm.arrow === 'before',
    'adminLink--arrowafter': _vm.arrow === 'after',
    'adminLink--button': _vm.button
  },attrs:{"to":_vm.to}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }